import { render, staticRenderFns } from "./handleRecord.vue?vue&type=template&id=32044789&scoped=true"
import script from "./handleRecord.vue?vue&type=script&lang=js"
export * from "./handleRecord.vue?vue&type=script&lang=js"
import style0 from "./handleRecord.vue?vue&type=style&index=0&id=32044789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32044789",
  null
  
)

export default component.exports